import { ErrorHandler, Injectable } from '@angular/core';
import { _LTracker as loggly } from 'loggly-jslogger';

@Injectable({
	providedIn: 'root'
})
export class NgxLoggerService {
	constructor (private errorHandler: ErrorHandler) {}

	// Static method should only be used for non-Angular classes
	public static logError (...params) {
		if(!params[0]) return;
		params.push((new Error()).stack);
		loggly.push(params);
		// eslint-disable-next-line no-console
		console.error(...params);
	};

	public logError (...params: any[]) {
		NgxLoggerService.logError(...params);
	}

	public logWarn (...params: any[]) {
		if(!params[0]) return;
		params.push((new Error()).stack);
		loggly.push(params);
		// eslint-disable-next-line no-console
		console.warn(...params);
	}

	public log (value: any, ...rest: any[]) {
		// eslint-disable-next-line no-console
		console.log(value, ...rest);
	}

	public error (error: any) {
		this.errorHandler.handleError(error);
	}

	public warn (value: any, ...rest: any[]) {
		// eslint-disable-next-line no-console
		console.warn(value, ...rest);
	}
}
